module.exports = __webpack_public_path__ + "static/img/123.2aa032d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/123.gif
// module id = EtrC
// module chunks = 2